<template>
  <div class="content-430">
    <div class="process-list">
      <ul class="process-box">
        <li class="blue">开始</li>
        <li>学校确认教师考勤单</li>
      </ul>
      <div class="line"></div>
      <ul class="process-box">
        <li class="blue">系统校验</li>
        <li>系统校验教师考勤单</li>
      </ul>

      <div class="line"></div>
      <ul class="process-box">
        <li class="green">结束</li>
        <li>平台结算</li>
      </ul>
      <Button
        type="primary"
        style="width: 140px; margin-top: 70px"
        @click="handleEnd"
        >结束</Button
      >
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() { },
  methods: {
    handleEnd() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.content-430 {
  text-align: center;
  .process-list {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 20px 50px;
    padding: 40px 0;
    text-align: center;
    background: #f2f2f2;
    .process-box {
      display: flex;
      flex-direction: column;
      width: 160px;
      height: 80px;
      background: #fff;
      border-radius: 10px;
      li {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
      }
      .blue {
        color: #fff;
        background: #188ffe;
        border-radius: 10px 10px 0 0;
      }
      .green {
        color: #fff;
        background: #63a103;
        border-radius: 10px 10px 0 0;
      }
    }
    .line {
      width: 1px;
      height: 60px;
      background: #515a6e;
    }
  }
}
</style>
